import React from "react";
import Background from "../components/Background";
import Navbar from "../components/Navbar";
import back from "../assets/icons/back.svg";
const streetLegends1 = require("../assets/images/modeling/WhatsApp Image 2024-05-26 at 22.18.27_8d5f94eb.jpg");

function Modeling() {
  return (
    <>
      <div className="relative bg-[#757575] h-screen overflow-y-auto overflow-x-hidden z-50">
        <div className=" absolute top-0 left-0 w-full h-full"></div>
        <Navbar type="modeling" image={back} />
        <div className="mx-20 z-50 flex justify-center items-center h-full">
          <img
            src={streetLegends1}
            alt="streetLegends1"
            width={500}
            style={{ opacity: 1 }}
          />
        </div>
      </div>
    </>
  );
}

export default Modeling;
